import { MediaCategoryTypeEnum } from '../enums/media-category-type.enum.model';
import { MediaTypeEnum } from '../enums/media-type.enum.model';
import { UtilityFunctions } from '../utilities/functions.models';



export class ProductListMediaDto {
  sourceVariantId: number;
  paletteId: number;
  mediaId: number;
  mediaOrder: number;
  mediaCategory: number;
  mediaType: number;
  resolutions: { [key: number]: string; };

  constructor(init?: ProductListMediaDto) {
    Object.assign(this, init);
    if (init.resolutions && Object.keys(init.resolutions)?.length > 0) {
      Object.keys(init.resolutions).forEach(key => {
        this.resolutions[key] = UtilityFunctions.fixImagePath(init.resolutions[key], 500, 'Image not found');
      });
    } else {
      this.resolutions[500] = UtilityFunctions.fixImagePath(null, 500, 'Image  found');
    }
  }
}

export class MediaByColorDTO {
  mediaRes: MediaResDTO[];
  paletteId: number;
}

export class MediaByColorVM {
  mediaRes: MediaShop[];
  paletteId: number;
  constructor(s?: Partial<MediaByColorVM>) {
    Object.assign(this, s);
  }
}

export class MediaShop {
  name: string;
  type: number;
  category: number;
  resolutions: { [key: number]: string; };

  constructor(s?: Partial<MediaShop>) {
    if (s) {
      Object.assign(<MediaShop>this, s);

      if (s.resolutions && Object.keys(s.resolutions)?.length > 0) {
        Object.keys(s.resolutions).forEach(key => {
          if (!s.resolutions[key].includes('https')) {
            this.resolutions[key] = `https:\\\\${s.resolutions[key]}`;
          } else {
            this.resolutions[key] = s.resolutions[key];
          }
        });
      }
    }
  }

  getRequestResolution(request: number): string {
    return UtilityFunctions.getRequestResolution(this.resolutions, request);
  }

  getMinResolution() {
    if (this.resolutions && Object.keys(this.resolutions).length > 0) {
      const minResKey = Math.min(...Object.keys(this.resolutions).map(x => Number(x)));
      return this.resolutions[minResKey];
    }
  }

  getMaxResolution() {
    if (this.resolutions && Object.keys(this.resolutions).length > 0) {
      const maxResKey = Math.max(...Object.keys(this.resolutions).map(x => Number(x)));
      return this.resolutions[maxResKey];
    }
  }

  isEmpty() {
    return !this.resolutions || !(Object.keys(this.resolutions)?.length > 0);
  }
}

export class Media {
  id: number;
  name: string;
  src: string;
  type: MediaTypeEnum;
  constructor(init?: Media) {
    Object.assign(this, init);
    this.src = UtilityFunctions.fixImagePath(this.src);
  }
}


export class MediaDTO extends Media {
  category: MediaCategoryTypeEnum;
  constructor(init?: MediaDTO) {
    super(init);
    Object.assign(this, init);
  }
}

export class MediaResDTO {
  id: number;
  name: string;
  resolutions: { [key: number]: string; };
  type: MediaTypeEnum;
  category: MediaCategoryTypeEnum;
  constructor(init?: MediaDTO) {
    Object.assign(this, init);
  }
}

export class OrderedMediaDTO {
  media: MediaDTO;
  order: number;
  visible: boolean;
  validityDateFrom: string;
  validityDateTo: string;
  constructor(init?: OrderedMediaDTO) {
    Object.assign(this, init);
  }
}

